import React, { memo } from 'react'

import arrow from 'images/three_d_studio/empty_state/arrow.webp'

function EmptyState() {
  return (
    <div className="empty-state">
      <p className="empty-state__text cgt-body-base-semibold">
        Create your first 3D Model and your library will appear here
      </p>
      <img
        className="empty-state__arrow"
        src={arrow}
        alt=""
        aria-hidden="true"
        width="58"
        height="22"
      />
    </div>
  )
}

export default memo(EmptyState)
